import React from 'react';
import LegalPage from '../components/LegalPage';
import privacy from '../legal/privacy';

const Privacy = () => <LegalPage content={privacy} />;

export default Privacy;
